<template>
  <ProgramSettingsFormWrapper
    setting-type="settings"
    :form-data="formData"
    :keys-to-reset="keysToReset"
    :disable-save.sync="disableSave"
    title="Privacy Settings"
  >
    <WtTile parent vertical :col="12">
      <WtSwitchQuestionInput
        v-model="communityFeedEnabled"
        label="Enable Community Feed"
        :tooltip-text="communityFeedTooltip"
        @input="disableSave = false"
      />
    </WtTile>
  </ProgramSettingsFormWrapper>
</template>

<script>
import WtTile from "@@/WtTile/WtTile.vue";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput.vue";
import ProgramSettingsFormWrapper from "@@/ProgramSettingsAdmin/ProgramSettingsFormWrapper.vue";
import { mapActions, mapGetters } from "vuex";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";

export default {
  name: "PrivacySettings",

  components: {
    WtTile,
    WtSwitchQuestionInput,
    ProgramSettingsFormWrapper
  },

  mixins: [programSettingsFormMixin],

  computed: {
    ...mapGetters("program", [
      "coreProgramMeta",
      "programSettingsCopy",
      "programLoaded"
    ]),

    communityFeedTooltip() {
      return "If this is turned off, the community feed will be hidden.";
    },

    formData() {
      return {
        communityFeedEnabled: this.programSettingsCopy.communityFeedEnabled
          ? 1
          : 0
      };
    },

    keysToReset() {
      return ["communityFeedEnabled"];
    },

    communityFeedEnabled: {
      set(communityFeedEnabled) {
        this.updateProgramSettingsCopy({
          key: "communityFeedEnabled",
          value: communityFeedEnabled
        });
      },
      get() {
        const val = this.programSettingsCopy.communityFeedEnabled;
        if (val === null || val === undefined) return 1;
        return val ? 1 : 0;
      }
    }
  },

  methods: {
    ...mapActions("program", ["updateProgramSettingsCopy"])
  }
};
</script>
